import { FC, useState } from "react";
import { AppButton } from "site/ui";
import styled from "styled-components";
import AddPaymentModal from "./AddPaymentModal";

const SectionTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #5575f7;
`;
const SubText = styled.p`
  margin: 5px 0;
  font-size: 14px;
  color: #6c757d;
`;

export interface PaymentPlanProps {
  
}
 export const PaymentPlan:FC<PaymentPlanProps> = ({
    
 }) => {
    const [openModal, setOpenModal] = useState(false)
    return (
      <div>
        <SectionTitle>Payment plan</SectionTitle>
        <h4>Payment methods</h4>
        <SubText>
          You currently do not have any payment methods added yet.
        </SubText>
        <AppButton
          variant="accent"
          style={{ marginTop: 20 }}
          onClick={() => setOpenModal(true)}
        >
          Add a payment method
        </AppButton>
        <AddPaymentModal {...{
          open: openModal,
          close: () => setOpenModal(false)
        }}/>
      </div>
    );
  }